import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AssignedColumns, RecentlyReleasedColumns } from './table_def'
import { Box, CircularProgress, Modal, Tooltip, Typography } from '@mui/material'
import Icon from '@mui/material/Icon'
import { useStyles } from './inboxStyles'
import PatientCaseHistory from '../Common/PatientCaseHistoryModal'
import FreezeReportingDialog from './FreezeReportingDialog'
import SnackBarAlert from '../../HOC/SnackBarAlert'
import Chip from '@mui/material/Chip'
import moment from 'moment-timezone'
import Stack from '@mui/material/Stack'
import {
  clearPremerisApiCache,
  clearPremerisReportApiCache,
  fetchInboxData,
  fetchCaseHistory,
  fetchRecentlyReleasedData,
  sendCompleteCaseDetails,
  sendStartCaseDetails,
  setCaseData,
  clearSessionToken,
  refreshCaseData,
  saveReportData,
  setDraftEmpty,
  amendReportUpload,
} from '../../../actions'
import { RootState } from '../../../reducers'
import Countdown from 'react-countdown'
import { CaseStatus } from './../../../utils/displayLabels'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import LaunchPremeris from '../../CaseDiagnosis/LaunchPremeris'
import LaunchMaskedModal from './LaunchMaskedModal'
import CustomDatagridDateRangeFilter from '../Common/CustomDatagridDateRangeFilter'
import { DataGrid, getGridStringOperators, GridFilterItem, GridFilterModel, GridFilterOperator } from '@mui/x-data-grid'

import CustomDatagridDropDownFilter from '../Common/CustomDatagridDropDownFilter'

function AssignedCases({ userId }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [freezOpen, setFreezOpen] = useState(false)
  const [premerisOpen, setPremerisOpen] = useState(false)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const dispatch = useDispatch()
  const assignData = useSelector((state: RootState) => state.inboxData)
  const { data, error } = useSelector((state: RootState) => state.inboxData)
  const caseData = useSelector((state: RootState) => state.getCaseData)
  const { historyData } = useSelector((state: RootState) => state.getCaseHistory)
  const [isReadOnlyMode, setReadOnlyMode] = useState(false)
  const [caseIdforTRFOpen, setTRFCaseNum] = useState('')
  const [caseNumber, setCaseNumber] = useState('')
  const [workflowId, setWorkflowId] = useState(2)
  const [patientFullName, setPatientFullName] = useState('')
  const refreshData = useSelector((state: RootState) => state.refreshCase)
  const recenlyReleased = useSelector((state: RootState) => state.recentlyReleasedData)
  const [userDetails, setUserDetails] = useState()
  const [pageValue, setPageValue] = useState(0)
  const { role, user } = useSelector((state: RootState) => state.userLogin)
  const { display_labels } = useSelector((state: RootState) => state.appConfig)
  const procedureData = useSelector((state: RootState) => state.getFilterProcedureCodeData)
  const { re_complete_success, re_complete_error } = useSelector((state: RootState) => state.completeCaseDataResponse)
  const { re_launch_success, re_launch_error } = useSelector((state: RootState) => state.launchPremerisDataResponse)
  const [openMaskedModal, setOpenMaskedModal] = useState(false)
  const [filterValue, setFilterValue] = useState('')
  const [filterName, setFilterName] = useState('created_datetime')
  const [sortOrder, setSortOrder] = useState('asc')
  const gridPageSize = 10
  const [isFirstPage, setFirstPage] = useState(false)
  const [isFilter, setFilter] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [sortField, setSortField] = useState('created_datetime')
  const [columnModel, setColumnModel] = useState('created_datetime')
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [
      {
        id: 1,
        columnField: 'quantity',
        value: [5000, 15000],
        operatorValue: undefined,
      },
    ],
  })
  const [refreshInProgress, setRefreshInProgress] = useState(false)
  const [findUrl, setFindUrl] = useState('')
  const totalAssignedCount = assignData.total_count
  const totalReleasedCount = recenlyReleased.total_count
  let recenlyReleasedData = []
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <>00:00:00</>
    } else {
      return (
        <span>
          {hours}:{minutes}:{seconds}
        </span>
      )
    }
  }

  if (recenlyReleased.data.length > 0) {
    recenlyReleasedData =
      recenlyReleased &&
      recenlyReleased?.data?.map((val) => {
        val.patient_full_name = `${val.patient_last_name}, ${val.patient_first_name}`
        return val
      })
  }

  const CaseStatusRenderer = {
    field: 'workflow_stage_id',
    headerName: 'Case Status',
    sortable: true,
    width: 260,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      const caseStatus = CaseStatus(params.row.stage_id, role, display_labels)
      const statusArray = caseStatus.labelStr.split(', ')
      const style = { backgroundColor: caseStatus.labelColor }
      return (
        <>
          {statusArray.map((caseStatus) => (
            // eslint-disable-next-line react/jsx-key
            <>
              <Tooltip title={caseStatus} placement="top-start">
                <Stack direction="row" spacing={2}>
                  <Chip className={classes.chipSpacing} color="primary" style={style} label={caseStatus} />
                </Stack>
              </Tooltip>
            </>
          ))}
        </>
      )
    },
  }

  const ProcedureCodeRenderer = {
    field: 'procedure_code',
    headerName: 'Case Type',
    width: 260,
    headerClassName: 'super-app-theme--header',
    sortable: true,
    disableClickEventBubbling: true,
    renderCell: (params) => {
      const procedureCodeResults = procedureData.procedureCodeMap.filter((value) => {
        return value.id == params.row.procedure_code
      })
      const value = procedureCodeResults[0]?.display ? procedureCodeResults[0]?.display : ''
      const truncatedValue = value.length >= 25 ? value.substring(0, 25) + '...' : value
      return (
        <Tooltip title={value} placement="top-start">
          <div>{truncatedValue}</div>
        </Tooltip>
      )
    },
  }

  const handleFilter = useCallback(
    (obj) => {
      setFilter(true)
      setFilterName(obj.filterField)
      setFilterValue(obj.filterValue)
      setStartDate(obj.startDate)
      setEndDate(obj.endDate)
      setSortField(obj.sortField ? obj.sortField : 'created_datetime')
    },
    [isFilter],
  )

  const quantityOnlyOperators: GridFilterOperator[] = [
    {
      label: 'Between',
      value: 'between',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }
        return null
      },
      InputComponent: CustomDatagridDateRangeFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: 'assigned' },
    },
  ]

  const dropdownOnlyOperators: GridFilterOperator[] = [
    {
      label: 'List',
      value: 'list',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }
        return null
      },
      InputComponent: CustomDatagridDropDownFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: 'assigned' },
    },
  ]

  const ColumnsCustomFilters = (columnsData: any) =>
    useMemo(() => {
      const newAssignedColumns = [...columnsData]

      if (newAssignedColumns.length > 0) {
        const assignedDateIndex = newAssignedColumns.findIndex((col) => col.headerName === 'Assigned On')
        const assignedIndex = newAssignedColumns.findIndex((col) => col.headerName === 'Assign By')
        const caseTypeIndex = newAssignedColumns.findIndex((col) => col.headerName === 'Case Type')
        const priorityIndex = newAssignedColumns.findIndex((col) => col.headerName === 'Priority')
        const workflowIndex = newAssignedColumns.findIndex((col) => col.headerName === 'Case Status')
        const patientNameIndex = newAssignedColumns.findIndex((col) => col.headerName === 'Patient Name')
        const trfIdIndex = newAssignedColumns.findIndex((col) => col.headerName === 'TRF ID')

        if (assignedDateIndex !== -1) {
          newAssignedColumns[assignedDateIndex] = {
            ...newAssignedColumns[assignedDateIndex],
            filterOperators: quantityOnlyOperators,
          }
        }
        if (assignedIndex !== -1) {
          newAssignedColumns[assignedIndex] = {
            ...newAssignedColumns[assignedIndex],
            filterOperators: dropdownOnlyOperators,
          }
        }
        if (caseTypeIndex !== -1) {
          newAssignedColumns[caseTypeIndex] = {
            ...newAssignedColumns[caseTypeIndex],
            filterOperators: dropdownOnlyOperators,
          }
        }
        if (priorityIndex !== -1) {
          newAssignedColumns[priorityIndex] = {
            ...newAssignedColumns[priorityIndex],
            filterOperators: dropdownOnlyOperators,
          }
        }
        if (workflowIndex !== -1) {
          newAssignedColumns[workflowIndex] = {
            ...newAssignedColumns[workflowIndex],
            filterOperators: dropdownOnlyOperators,
          }
        }
        if (patientNameIndex !== -1) {
          newAssignedColumns[patientNameIndex] = {
            ...newAssignedColumns[patientNameIndex],
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
          }
        }
        if (trfIdIndex !== -1) {
          newAssignedColumns[trfIdIndex] = {
            ...newAssignedColumns[trfIdIndex],
            filterOperators: getGridStringOperators().filter((operator) => operator.value === 'startsWith'),
          }
        }
      }

      return newAssignedColumns
    }, [AssignedColumns])

  AssignedColumns.push(ProcedureCodeRenderer)
  AssignedColumns.push(CaseStatusRenderer)

  const RecentlyIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    headerClassName: 'super-app-theme--header',
    width: 160,
    disableClickEventBubbling: true,
    filterable: false,
    renderCell: (params) => {
      const utcTime = params.row.updated_datetime
      const offset = moment().utcOffset()
      const localText = moment.utc(utcTime).utcOffset(offset).format('L LT')
      const date = Date.parse(localText)
      const difference = moment.utc().valueOf() - (date + 7200000)
      // var tempTime = moment.duration(difference);
      // var y = tempTime.hours() +":"+ tempTime.minutes();
      const in2HourWindow = difference > 0 ? false : true

      if (in2HourWindow) {
        return (
          <Tooltip title="Stop the report from releasing" placement="top-start">
            <Icon onClick={(event) => handleFreezOpen(event, params.row)} color="error">
              dangerous
            </Icon>
          </Tooltip>
        )
      } else {
        return (
          <Tooltip title="Stop the report from releasing" placement="top-start">
            <Icon color="disabled">dangerous</Icon>
          </Tooltip>
        )
      }
    },
  }

  const RecentlyHoldRender = {
    field: 'updated_datetime',
    headerName: 'Hold Time Ending',
    sortable: true,
    headerClassName: 'super-app-theme--header',
    width: 182,
    disableClickEventBubbling: true,
    renderCell: (params) => {
      const utcTime = params.row.updated_datetime
      const offset = moment().utcOffset()
      const localText = moment.utc(utcTime).utcOffset(offset).format('L LT')
      const date = Date.parse(localText)
      return <Countdown date={date + 7200000} renderer={renderer} />
    },
  }
  RecentlyReleasedColumns.push(ProcedureCodeRenderer)
  RecentlyReleasedColumns.push(CaseStatusRenderer)
  RecentlyReleasedColumns.unshift(RecentlyHoldRender)
  RecentlyReleasedColumns.push(RecentlyIconRender)

  useEffect(() => {
    setFindUrl(window.location.pathname)
  }, [])

  const handleOpen = (event, row: any) => {
    setUserDetails(row)
    dispatch(fetchCaseHistory(row.case_id, role))
    setOpen(true)
  }

  const handleFreezOpen = (event, row: any) => {
    setUserDetails(row)
    setFreezOpen(true)
  }

  const handlePageChange = async (page, details) => {
    await dispatch(
      fetchInboxData({
        id: `${userId}`,
        pageIndex: page + 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : columnModel,
        filterValue: filterValue,
        caseView: 'assigned',
        startDate: startDate,
        endDate: endDate,
        sortOrder: sortOrder,
        sortField: sortField,
      }),
    )
  }

  const handleFilteredPageChange = async (page: any, details: any) => {
    setSortOrder(details[0].sort)

    await dispatch(
      fetchInboxData({
        id: `${userId}`,
        caseView: 'assigned',
        filterField: filterName !== '' ? filterName : details[0].field,
        filterValue: filterValue,
        startDate: startDate,
        endDate: endDate,
        sortOrder: details[0].sort ? details[0].sort : 'asc',
        sortField: details[0].field,
        pageIndex: page + 1,
        pageSize: gridPageSize,
      }),
    )
  }

  const handleReleasedPageChange = async (page, details) => {
    await dispatch(
      fetchRecentlyReleasedData({
        id: `${userId}`,
        pageIndex: page + 1,
        pageSize: gridPageSize,
        filterField: 'case_number',
        filterValue: null,
        caseView: 'recently_released',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
  }

  const handleMaskedOpen = (event, params) => {
    setPremerisOpen(false)
    setOpenMaskedModal(true)
    setTRFCaseNum(params.row.case_id)
    setCaseNumber(params.row.case_number)
    setWorkflowId(params.row.workflow_stage_id)
    const patientName = `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`
    setPatientFullName(patientName)
  }

  const handlePremerisOpen = async (event, caseId: any, data) => {
    // Prevent multiple concurrent case openings
    if (refreshInProgress) {
      return
    }

    /* Emptying the get draft report data when different case is selected, to prevent caching */
    dispatch(setDraftEmpty({ draft: {} }))

    // Clear API caches to prevent data conflicts between cases
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())

    setTRFCaseNum(caseId)
    const filterAssignedResults = data.filter((value) => {
      return value.case_id == caseId
    })

    if (!filterAssignedResults.length) {
      console.error('Case not found in data:', caseId)
      return
    }

    const patientName = `${filterAssignedResults[0].patient_last_name || ''}, ${
      filterAssignedResults[0].patient_first_name || ''
    }`
    setPatientFullName(patientName)
    setCaseNumber(filterAssignedResults[0].case_number)

    setRefreshInProgress(true)
    await handleRefreshCases(filterAssignedResults[0].case_number + '000')

    // Set case data before calling handleTRFStart to ensure proper state
    const currentCaseData = {
      pathologist: { first_name: filterAssignedResults[0].first_name, last_name: filterAssignedResults[0].last_name },
      pathologistId: filterAssignedResults[0].user_id,
      caseNumber: filterAssignedResults[0].case_number,
      procedureCodeId: filterAssignedResults[0].procedure_code,
      workflowId: filterAssignedResults[0].stage_id,
      patientName: patientName,
      caseId: caseId,
      nlOrderId: filterAssignedResults[0].nl_order_id,
      userCaseWorkflowId: filterAssignedResults[0].id,
      slideStatusId: filterAssignedResults[0].slide_status_id,
      mcFlag: filterAssignedResults[0].mc_flag,
      statFlag: filterAssignedResults[0].stat_flag,
    }

    dispatch(setCaseData(currentCaseData))

    handleTRFStart(caseId, filterAssignedResults[0].workflow_stage_id, filterAssignedResults[0].stage_id)

    setRefreshInProgress(false)

    setPremerisOpen(true)
  }

  const handleTRFStart = (caseid, updatedWorkflowId, updatedWorkflowStage) => {
    setPremerisOpen(false)
    if (updatedWorkflowId === 4 || updatedWorkflowId === 10) {
      setPremerisOpen(true)
      setReadOnlyMode(false)
    } else if (
      updatedWorkflowStage === 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT' ||
      updatedWorkflowStage === 'CORRECT_ASSIGNED_CONSULT'
    ) {
      setPremerisOpen(true)
      setReadOnlyMode(true)
    } else {
      dispatch(
        sendStartCaseDetails({
          id: userId,
          caseid: caseid,
        }),
      )
      setTimeout(updateTrfStartDataTable, 1500)
    }
  }

  const updateTrfStartDataTable = async () => {
    dispatch(
      fetchInboxData({
        id: `${userId}`,
        pageIndex: pageValue + 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: filterValue,
        caseView: 'assigned',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    dispatch(
      fetchRecentlyReleasedData({
        id: `${userId}`,
        pageIndex: 1,
        pageSize: gridPageSize,
        filterField: 'case_number',
        filterValue: null,
        caseView: 'recently_released',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
  }

  const handleRefreshCases = async (trfBarcode) => {
    await dispatch(refreshCaseData({ trfBarcode: trfBarcode }))
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
  }

  const handleTRFComplete = async (caseid) => {
    // Use the passed caseid parameter instead of the potentially stale caseIdforTRFOpen
    const targetCaseId = caseid || caseIdforTRFOpen

    await dispatch(
      saveReportData({
        trfBarcode: null,
        cptCodes: [],
        saveDraftJSON: {},
        reason: '',
        diagnosisLP: {},
        consultLP: [],
        calloutDecision: false,
        procedureCode: null,
      }),
    )
    await dispatch(
      amendReportUpload({
        pathologistId: '',
        caseNumber: '',
        caseId: '',
        nlOrderId: '',
        userCaseWorkflowId: '',
        slideStatusId: '',
        mcFlag: '',
        statFlag: '',
        userId: '',
      }),
    )
    await dispatch(
      sendCompleteCaseDetails({
        id: `${userId}`,
        caseid: `${targetCaseId}`,
        indicator: 'NORMAL',
      }),
    )
    await dispatch(clearSessionToken())
    setTimeout(updateDataTable, 1500)
  }

  const updateDataTable = async () => {
    setOpenSuccessSnackBar(true)
    if (data) {
      await dispatch(
        setCaseData({
          pathologist: caseData.pathologist,
          pathologistId: caseData.pathologistId,
          caseNumber: caseData.caseNumber,
          procedureCodeId: caseData.procedureCodeId,
          workflowId: updateWorklowStage(caseData.workflowId),
          patientName: caseData.patientName,
          caseId: caseData.caseId,
          nlOrderId: caseData.nlOrderId,
          userCaseWorkflowId: caseData.userCaseWorkflowId,
          slideStatusId: caseData.slideStatusId,
          mcFlag: caseData.mcFlag,
          statFlag: caseData.statFlag,
        }),
      )
    }
    await dispatch(
      fetchInboxData({
        id: `${userId}`,
        pageIndex: pageValue,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: null,
        caseView: 'assigned',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    await dispatch(
      fetchRecentlyReleasedData({
        id: `${userId}`,
        pageIndex: 1,
        pageSize: gridPageSize,
        filterField: 'case_number',
        filterValue: null,
        caseView: 'recently_released',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    setTimeout(() => setOpenSuccessSnackBar(false), 2000)
  }

  const updateWorklowStage = (type) => {
    switch (type) {
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS':
        return 'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW'
      case 'CORRECT_ASSIGNED_INPROGRESS':
        return 'CORRECT_RESULTED_2HRWINDOW'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_READY':
        return 'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW'
      case 'CORRECT_ASSIGNED_READY':
        return 'CORRECT_RESULTED_2HRWINDOW'
    }
  }

  const onFilterChange = async (model: GridFilterModel) => {
    setFilterName('')
    setFilterValue('')
    setStartDate('')
    setEndDate('')
    setFilterModel(model)
    if (model.items.length && model.items[0].value) {
      await onFilterApply(model)
    } else {
      await clearFilter()
      setFilter(false)
    }
  }

  const onFilterApply = React.useCallback(async (model: GridFilterModel) => {
    if (model.items.length) {
      if (
        (model.items[0].columnField === 'patient_first_name' || model.items[0].columnField === 'case_number') &&
        model.items[0].value &&
        model.items[0].value.length
      ) {
        const val = model.items[0].value
        setFilterValue(val)
        const name = model.items[0].columnField
        setFilterName(name)
        await dispatch(
          fetchInboxData({
            id: user,
            caseView: 'assigned',
            filterField: model.items[0].columnField,
            filterValue: val,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
        setFilter(true)
      }
    }
  }, [])

  const clearFilter = async () => {
    //const apiRef = useGridApiContext();
    await dispatch(
      fetchInboxData({
        id: `${userId}`,
        pageIndex: pageValue,
        pageSize: gridPageSize,
        filterField: 'created_datetime',
        filterValue: null,
        caseView: 'assigned',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    //apiRef.current.hideFilterPanel()
  }

  const handleClose = () => setOpen(false)
  const handleFreezClose = () => setFreezOpen(false)

  const handlePremerisClose = async () => {
    await updateTrfStartDataTable()
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
    setPremerisOpen(false)
  }
  /*  const filterOperators = getGridStringOperators().filter(({ value }) =>
   ['equals'  ].includes(value),
 ); */
  const handleMaskedClose = () => setOpenMaskedModal(false)

  if (error) return <SnackBarAlert severity="error" message="Server error" />

  const caseId = historyData && historyData?.case_history ? historyData?.case_history[0]?.id : null

  return (
    <div className={classes.container}>
      {
        <Modal
          open={(refreshData && refreshData.fetchInProgress) || refreshInProgress}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <CircularProgress
              style={{ marginLeft: '45%', marginTop: '40vh', position: 'absolute', color: '#0A688D' }}
            />
            <Typography
              style={{
                fontWeight: 'bolder',
                color: 'rgba(255,255,255,0.8)',
                fontSize: 'larger',
                marginLeft: '35%',
                marginTop: '47vh',
                position: 'absolute',
              }}
            >
              Refreshing the case details from LabOS...
            </Typography>
          </div>
        </Modal>
      }
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <PatientCaseHistory userDetails={userDetails} handleClose={handleClose} />
        </Box>
      </Modal>
      {<FreezeReportingDialog open={freezOpen} userId={userId} onClose={handleFreezClose} userDetails={userDetails} />}
      {openSuccessSnackBar && re_complete_success && <SuccessSnackBar message="Successfully updated case status" />}
      {openSuccessSnackBar && re_complete_error && <ErrorSnackBar message="Failed to update case status" />}
      {openSuccessSnackBar && re_launch_success && <SuccessSnackBar message="Successfully updated case status" />}
      {openSuccessSnackBar && re_launch_error && <ErrorSnackBar message="Failed to update case status" />}
      <Modal
        open={premerisOpen}
        onClose={handlePremerisClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <LaunchPremeris
          caseView={'assigned'}
          urlLink={findUrl}
          handlePremerisClose={handlePremerisClose}
          handleTRFComplete={handleTRFComplete}
          isReadOnlyMode={isReadOnlyMode}
          isAmendFlow={false}
        />
      </Modal>
      <Modal
        open={openMaskedModal}
        onClose={handleMaskedClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <LaunchMaskedModal
          caseId={caseId}
          patientName={patientFullName}
          trfId={caseNumber}
          handleClose={handleMaskedClose}
          handleStart={handleTRFStart}
          handleComplete={handleTRFComplete}
          workflow={workflowId}
        />
      </Modal>
      {open}
      <Box
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#0d688d73',
            fontWeight: '600',
          },
          '& .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'transparent !important',
          },
          '& .MuiDataGrid-cell:hover': {
            cursor: 'pointer !important',
          },
          '& .MuiDataGrid-filterForm': { p: 2 },
        }}
      >
        <DataGrid
          disableColumnSelector
          autoHeight
          rows={assignData.data}
          columns={ColumnsCustomFilters(AssignedColumns)}
          pagination
          page={isFirstPage ? 0 : pageValue}
          pageSize={10}
          paginationMode="server"
          rowCount={totalAssignedCount}
          className={classes.filter}
          loading={assignData.fetchInProgress}
          onCellClick={(params, event) => {
            event.defaultMuiPrevented = true
            if (params.field === '') {
              return
            } else {
              if (
                params.row.stage_id === 'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL' ||
                params.row.stage_id === 'CORRECT_ASSIGNED_INITIAL'
              ) {
                handleMaskedOpen(event, params)
              } else {
                setReadOnlyMode(false)
                handlePremerisOpen(event, params.row.case_id, assignData.data)
              }
            }
          }}
          onPageChange={(page, details) => {
            handlePageChange(page, details)
            setPageValue(page)
            setFirstPage(false)
          }}
          filterModel={filterModel}
          onFilterModelChange={(model) => onFilterChange(model)}
          componentsProps={{
            filterPanel: {
              filterFormProps: {
                // Customize inputs by passing props
                columnInputProps: {
                  variant: 'outlined',
                  size: 'small',
                  sx: { mt: 'auto' },
                },
                operatorInputProps: {
                  variant: 'outlined',
                  size: 'small',
                  sx: { mt: 'auto' },
                },
                valueInputProps: {
                  required: true,
                },
              },
              sx: {
                // Customize inputs using css selectors
                '& .MuiDataGrid-filterForm': {
                  p: 2,
                  display: 'block',
                  width: 'fit-content',
                  justifyContent: 'flex-start',
                },
                '& .MuiDataGrid-filterForm:nth-child(even)': {},
                '& .MuiDataGrid-filterFormLinkOperatorInput': { mr: 2 },
                '& .MuiDataGrid-filterFormColumnInput': { mr: 2, width: 150 },
                '& .MuiDataGrid-filterFormOperatorInput': { mr: 2 },
                '& .MuiDataGrid-filterFormValueInput': { width: 'fit-content' },
              },
            },
            panel: {
              sx: {
                '& .MuiDataGrid-panelWrapper': { overflow: 'visible' },
                '& .MuiDataGrid-panelContent': { overflow: 'visible', display: 'flex' },
                '& .MuiFormControl-root': {
                  width: 'auto',
                  minWidth: '55px',
                  marginRight: '18px',
                  justifyContent: 'end',
                },
              },
            },
          }}
          onSortModelChange={(newSortModel) => {
            if (newSortModel.length) setSortField(newSortModel[0].field)
            setPageValue(0)
            handleFilteredPageChange(pageValue, newSortModel)
          }}
        />
      </Box>
      <div className={classes.mt}>
        <h3>Recently Released</h3>
        <Box
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d688d73',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnHeader--moving': {
              backgroundColor: 'transparent !important',
            },
            '& .MuiDataGrid-cell:hover': {
              cursor: 'pointer !important',
            },
          }}
        >
          <DataGrid
            disableColumnSelector
            autoHeight
            pagination
            pageSize={10}
            paginationMode="server"
            rowCount={totalReleasedCount}
            rows={recenlyReleasedData}
            columns={RecentlyReleasedColumns}
            loading={recenlyReleased.fetchInProgress}
            onCellClick={(params, event) => {
              event.defaultMuiPrevented = true
              if (params.field === '') {
                return
              } else {
                setReadOnlyMode(true)
                handlePremerisOpen(event, params.row.case_id, recenlyReleasedData)
              }
            }}
            onPageChange={(page, details) => {
              handleReleasedPageChange(page, details)
            }}
          />
        </Box>
      </div>
    </div>
  )
}

export default AssignedCases
